export const externalLink = url => window.open(url,'_blank');